import React from "react";
import { Link } from "react-router-dom";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

import SectionCard from "../../components/SectionCard";

export default function DashboardSupport() {
    const theme = useTheme();

    return (
        <Container
            disableGutters
            sx={{
                width: "100%",
                mx: "auto",
                maxWidth: {
                    xs: "100%",
                    sm: 660,
                    md: 700,
                },
                mt: { xs: 1, sm: 2 },
                pb: { xs: 2, sm: 3 },
            }}
        >
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <SectionCard title="Support">
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                        }}
                    >
                        <Box>
                            <Typography
                                variant="caption"
                                color="text.secondary"
                                sx={{ mb: 1 }}
                            >
                                We're here to help! Get in touch with us through
                                any of the channels below.
                            </Typography>
                        </Box>

                        <Box>
                            <Typography
                                variant="subtitle1"
                                sx={{ mb: 1, fontWeight: 700 }}
                            >
                                Email Support
                            </Typography>
                            <Typography
                                variant="caption"
                                color="text.secondary"
                            >
                                Send us an email at{" "}
                                <Box
                                    component="a"
                                    href="mailto:avianjonasbusiness@gmail.com"
                                    sx={{
                                        color: theme.palette.primary.main,
                                        textDecoration: "none",
                                        fontWeight: 600,
                                        "&:hover": {
                                            textDecoration: "underline",
                                        },
                                    }}
                                >
                                    support
                                </Box>
                            </Typography>
                        </Box>

                        {/* <Box>
                            <Typography
                                variant="h6"
                                sx={{ mb: 1, fontWeight: 700 }}
                            >
                                Frequently Asked Questions
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Check out our{" "}
                                <Link
                                    to="/dashboard/integrations"
                                    style={{
                                        color: theme.palette.primary.main,
                                        textDecoration: "none",
                                        fontWeight: 600,
                                    }}
                                >
                                    Integrations
                                </Link>{" "}
                                page for configuration help, or review your{" "}
                                <Link
                                    to="/dashboard/pricing"
                                    style={{
                                        color: theme.palette.primary.main,
                                        textDecoration: "none",
                                        fontWeight: 600,
                                    }}
                                >
                                    Pricing
                                </Link>{" "}
                                information.
                            </Typography>
                        </Box> */}
                    </Box>
                </SectionCard>
            </Box>
        </Container>
    );
}
